import { jsx as _jsx } from "@emotion/react/jsx-runtime";
// External dependencies
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
;
/**
 * Main
 * @param {MainProps} props
 */
export const Main = function (props) {
    const { outputLanguage, drawerWidth } = props;
    return (_jsx(Box
    // Main page
    , Object.assign({ 
        // Main page
        component: "main", sx: {
            backgroundColor: 'transparent',
            margin: {
                md: `0 0 0 ${drawerWidth}`,
                xs: '0',
            },
            padding: '64px 0.5rem 1rem',
            height: '100%',
            boxSizing: 'border-box',
        } }, { children: _jsx(Outlet
        // Other components outlet
        , { 
            // Other components outlet
            context: { outputLanguage } }) })));
};
